import { Injectable } from '@angular/core';
import { ConfigurationsService } from '@icc/configurator/shared';
import { EventBusService } from '@icc/shared';
import { ExchangeRate } from '@icc/shared/currency';
import { ConfigurationType } from '@icc/shared/types';
import { PriceBaseService2 } from './price-base.service';
import { Promotion } from 'libs/b2b/shared/src/lib/interfaces/promotion.interface';

/**
 * Usługa liczenia ceny
 *
 * @export
 * @class PriceService
 */
@Injectable()
export class PriceService2 {
    syncRequests = 0;
    syncingPrice = false;
    prices: {
        rasters?: any[],
        prices?: any[],
        marketFactor?: number,
        taxRate?: number,
        charge?: number,
        isGross?: boolean,
        multiplier?: number,
        priceVersionId?: number,
        contractorCompanyId?: number | null,
        promotions?: Promotion[],
        promotion?: Promotion,
        priceRevision?: number,
        priceRastersRevision?: number,
    } = {
        rasters: [],
        prices: [],
        marketFactor: 1,
        charge: 1,
        taxRate: 0,
        isGross: false,
        multiplier: 1,
        priceVersionId: 0,
        contractorCompanyId: null,
        promotions: [],
        promotion: null,
        priceRevision: 0,
        priceRastersRevision: 0,
    };

    /**
     * Creates an instance of PriceService.
     *
     * @param {ng.ui.bootstrap.IModalService} $uibModal $uibModal
     * @param {any} ConfigurationsService ConfigurationsService
     * @param {PriceBaseService2} priceBaseService PriceBaseService
     *
     * @memberOf PriceService
     */
    constructor(
        private configurationsService: ConfigurationsService,
        private priceBaseService: PriceBaseService2,
        private eventBusService: EventBusService,
    ) {
    }

    async syncPrice(fromTimeout = false) {
        if (this.syncRequests > 0 || this.configurationsService.conf?.Current && !this.configurationsService.conf?.Current?.PriceValid) {
            this.syncRequests = 0;

            this.priceBaseService.setPrice(this.configurationsService.conf.Current, this.prices);
            if (fromTimeout) {
                this.eventBusService.post({
                    key: 'updatedPrice',
                    value: null
                });
            }
        }

        if (this.syncingPrice) {
            setTimeout(() => {
                this.syncPrice(true);
            }, 100);
        }
    }

    /**
     * Przelicza cenę
     *
     * @param {*} config Konfiguracja
     * @param {*} [offer]  Oferta
     * @returns {number} Wyliczona cena
     *
     * @memberOf PriceService
     */
    count(config?, additionalPriceModifier?) {
        if (config) {
            return this.priceBaseService.setPrice(config, this.prices, additionalPriceModifier);
        } else {
            if (this.configurationsService.conf?.Current?.PriceValid) {
                this.configurationsService.conf.Current.PriceValid = false;
            }
            this.syncRequests++;
            return NaN;
        }
    }

    /**
     * Otwiera modal szczegółow wyceny
     *
     * @param {any} config
     *
     * @memberOf PriceService
     */
    showPriceDetailsModal(config: ConfigurationType) {
        // this.priceDetailsService.showPriceDetailsModal(config);
    }

    getProductPromotion(productId: number): Promotion | undefined {
        const matchingPromotions = (this.prices.promotions || []).filter(el => {
            if (el.dateFrom && el.dateFrom > new Date()) {
                return false;
            }
            if (el.dateTo && el.dateTo < new Date()) {
                return false;
            }

            return el.model === 'Products' && (!el.record?.length || el.record.map(Number).includes(+productId));
        }).sort((a, b) => b.priority - a.priority);

        return matchingPromotions[0];
    }

    getMultiplier() {
        let multiplier = 1;

        if (!this.prices) {
            return multiplier;
        }

        if (this.prices.charge) {
            multiplier = multiplier * this.prices.charge;
        }
        if (this.prices.marketFactor) {
            multiplier = multiplier * this.prices.marketFactor;
        }
        if (this.prices.multiplier) {
            multiplier = multiplier * this.prices.multiplier;
        }

        return multiplier;
    }
}
